import { useMutation } from "react-query";
import { extendedPostJSON } from "../api/http";
import { endpoints } from "../api/endpoints";
import { useState } from "react";

interface IContractSms {
  pin?: string;
}

const postContractSms = (id: string, data: any) =>
  extendedPostJSON(endpoints.contracts.details + `/${id}/sign`, data);

export const useContractSms = (id: string) => {
  const [errors, setErrors] = useState<string[]>([]);
  const [action, setAction] = useState("");

  const { mutate, isLoading, isSuccess, isError, reset } = useMutation(
    (data: IContractSms) => postContractSms(id, data),
    {
      onSuccess: ({ data }) => {
        if (data === true) {
          setAction("sign_confirmed");
        } else if (data > 0) {
          setAction("sms_send");
        }
      },
      onError: (error: any) => {
        setErrors(Object.values(error?.data.errors || {}));
      },
      onSettled: () => {},
    }
  );

  return {
    isLoading,
    isSuccess,
    isError,
    errors,
    action,
    contractSms: mutate,
    resetForm: reset,
  };
};
